import React from 'react';
import './AboutAgathiyar.css';

const AboutAgathiyar = () => {
  return (
    <div className="agathiyar-background">
      <div className="agathiyar-content">
        <h1>About Agathiyar</h1>
        <p>
          Agathiyar (also spelled Agastya) is one of the most revered sages in Indian spiritual tradition and Siddha
          medicine. A central figure in Tamil Siddha philosophy, Agathiyar is celebrated for his profound
          contributions to both spiritual practices like meditation and ancient holistic medicine.
        </p>
        <h2>Master of Meditation</h2>
        <p>
          Agathiyar's teachings on meditation emphasize inner silence, breath control (pranayama), and
          consciousness expansion. He taught that true wisdom arises when the mind is still and aligned with the
          soul’s natural rhythm. His meditative practices are not just for personal peace but are intended as tools for
          spiritual awakening and cosmic unity.
        </p>
        <p>
          According to ancient texts, Agathiyar attained deep states of samadhi (absorption) and passed on
          meditation techniques that integrate body, breath, and mantra. His methods are designed to purify the
          subtle energy channels (nadis) and awaken the latent spiritual energy, or Kundalini, leading the seeker to
          liberation (moksha).
        </p>
        <h2>Pioneer of Siddha Medicine</h2>
        <p>
          Agathiyar is also recognized as the founding father of Siddha medicine, one of the oldest traditional
          healing systems in the world. Rooted in Tamil culture, Siddha medicine is a holistic approach that
          integrates herbal remedies, mineral preparations, yogic practices, and diet.
        </p>
        <p>
          Agathiyar authored numerous palm-leaf manuscripts detailing cures for diseases, methods of
          detoxification, and rejuvenation (Kayakalpa). He viewed the body as a sacred vessel and emphasized
          balance between the three humors (vata, pitta, kapha), aligning the physical body with spiritual discipline.
        </p>
        <h2>Unity of Body, Mind, and Spirit</h2>
        <p>
          What makes Agathiyar’s work unique is the seamless integration of spirituality and science. For him,
          healing was not merely physical—it was a pathway to deeper self-realization. Meditation and medicine
          were not separate pursuits but complementary paths toward human perfection.
        </p>
        <p>
          Agathiyar's legacy continues to inspire spiritual seekers, healers, and yogis across the world. His life is a
          testament to the timeless truth that inner stillness and compassionate care for the body are both
          essential for true health and enlightenment.
        </p>
      </div>
    </div>
  );
};

export default AboutAgathiyar;
